const status = {
    todo: {id: 1, name: '未執行', label: 'todo'},
    finding: {id: 2, name: '委託中', label: 'finding'}, // 委託中
    matched: {id: 3, name: '已配對', label: 'matched'}, // 已配對
    rematching: {id: 4, name: '重新配對中', label: 'rematching'}, // 重新配對中
    done: {id: 5, name: '完成', label: 'done'}, // 完成
    failed: {id: 6, name: '失敗', label: 'failed'}, // 失敗
    cancelled: {id: 7, name: '取消', label: 'cancelled'}, // 取消
    accepted: {id: 8, name: '接受', label: 'accepted'}, // 接受
    refused: {id: 9, name: '拒絕', label: 'refused'}, // 拒絕
    chating: {id: 10, label: 'chating', name: '通話中'},
    waiting: {id: 11, label: 'waiting', name: '等待中'},
    editing: {id: 12, name: '編輯中', label: 'editing'}, // 編輯中
    chatRoomReadied: {id: 13, name: '諮詢室已開', label: 'chatRoomReadied'}, // 諮詢室已開
    chatRoomClosed: {id: 14, name: '諮詢室已關', label: 'chatRoomClosed'}, // 諮詢室已關
    medicalGo: {id: 15, name: '顧問出發', label: 'medicalGo'},  // 顧問出發
    medicalArrived: {id: 16, name: '顧問抵達', label: 'medicalArrived'},  // 顧問抵達
    addTime: {id: 17, name: '延長服務', label: 'addTime'},  // 延長服務
    demandChange: {id: 18, name: '需求變更', label: 'demandChange'},  // 需求變更
    suggested: {id: 19, label: 'suggested', name: '完成建議'},
    reported: {id: 20, label: 'reported', name: '交班完成'},
    finish: {id: 21, label: 'finish', name: '結束任務'}, // 會談之後, 接下來可以醫師建議 & 評分
    otherAccepted: {id: 22, name: '其他醫師已接走任務', label: 'otherAccepted'}, // 其他醫師已接走任務
    enable: {id: 23, name: '開通', label: 'enable'}, // 開通
    applying: {id: 24, name: '申請中', label: 'applying'}, // 申請中
    disable: {id: 25, name: '停用', label: 'disable'},  // 停用
    validateFail: {id: 26, label: 'validateFail', name: '驗證失敗'},
    validateSuccess: {id: 27, label: 'validateSuccess', name: '驗證成功'},
    concernMiss: {id: 28, label: 'concernMiss', name: '連絡不到'},
    deleted: {id: 29, label: 'deleted', name: '註銷'},
    vipCancelled: {id: 30, label: 'vipCancelled', name: 'VIP取消'},
    vipPaid: {id: 31, label: 'vipPaid', name: '審核成功'}, // 付款成功 => 為了 APPLE 審核改 name
    assign: {id: 32, label: 'assign', name: '指派'},
    creditOk: {id: 33, label: 'creditOk', name: '已給', relate_table: 'mission'},
    medicalTimeSetted: {id: 34, label: 'medicalTimeSetted', name: '醫師已選可預約時段', relate_table: 'mission'},
    reserved: {id: 35, label: 'reserved', name: '預約成功', relate_table: 'mission'},
    isMedicalSelfVisit: {id: 36, label: 'isMedicalSelfVisit', name: '醫生親自探視', relate_table: 'mission'},
    vipCancelledAfterMedicalAccept: {id: 37, label: 'vipCancelledAfterMedicalAccept', name: '接受後VIP取消', relate_table: 'task'},
};

export const account_status = {
    //VIP開通前狀態：註冊 驗證 通知 簽約 付款 核對 開通
    //MEDICAL開通前狀態：註冊 驗證 簽約 核對 開通
    registered: {
        id: 1,
        name: '等待驗證電子郵件',
        label: 'to_validate',
        color: 'bg-blue text-white'
    },
    validated: {
        id: 2,
        name: '等待通知',
        label: 'to_call',
        color: 'bg-red text-white'
    },
    notified: {
        id: 3,
        name: '等待簽約',
        label: 'to_contract',
        color: 'bg-blue text-white'
    },
    contracted: {
        id: 4,
        name: '等待付款',
        label: 'to_pay',
        color: 'bg-yellow-darker text-white'
    },
    tocheck: {
        id: 5,
        name: '等待核對',
        label: 'to_check',
        color: 'bg-blue text-white'
    },
    activated: {
        id: 6,
        name: '已開通',
        label: 'activated',
        color: 'bg-green text-white'
    },
    //開通中異常狀態：驗證失敗
    validateFail: {
        id: 7,
        label: 'validateFail',
        name: '驗證失敗',
        color: 'bg-red text-white'
    },

    //開通後可能狀態：停用
    disabled: {
        id: 8,
        name: '停用',
        label: 'disabled',
        color: 'bg-grey-darker text-white'
    },  // 停用
};


export const canActivatedStatus = [
    account_status.validated.label,
    account_status.disabled.label,
    account_status.tocheck.label,
    account_status.contracted.label,
];

export const canChoosePlanStatus = [
    account_status.notified.label,
    account_status.tocheck.label,
    account_status.activated.label,
    account_status.disabled.label,
];

export const canContractStatus2 = [
    account_status.validated.label,
    account_status.notified.label,
    account_status.registered.label,
];


export default status;



// WEBPACK FOOTER //
// ./src/constants/status.js